import { setContext } from '@apollo/client/link/context';
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

let uri = 'https://ethical-gnat-87.hasura.app/v1/graphql';
const authorization = 'w2Gknuv7J$n9A2Bg4C6';

const cache = new InMemoryCache();
const httpLink = new HttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization,
      'x-hasura-admin-secret': authorization,
    },
  };
});


export const hasuraClient = new ApolloClient({
  cache,
  link: authLink.concat(httpLink),
});

